import { Button } from 'antd';
import {SaveOutlined, CopyOutlined, CloseOutlined, DeleteOutlined, CheckOutlined} from '@ant-design/icons';
import React from "react";
import { DIALOG_KEY } from "../../utils/enum";

const customStyle = { marginLeft: '5px', marginRight: '5px', whiteSpace: 'nowrap' };

export const SaveButton = ({ onClick, handleSetDialog, disabled }) => {
    return (
        <Button
            className="custom-edit-button"
            type="default"
            icon={<SaveOutlined />}
            style={customStyle}
            onClick={() =>
                handleSetDialog([
                    { key: DIALOG_KEY.OPEN, value: true },
                    { key: DIALOG_KEY.TITLE, value: "저장 확인" },
                    { key: DIALOG_KEY.BODY, value: "저장 하시겠습니까?" },
                    { key: DIALOG_KEY.HANDLE, value: onClick },
                    { key: DIALOG_KEY.BUTTON_TEXT, value: "저장" },
                    { key: DIALOG_KEY.USE_INPUT, value: false }
                ])
            }
            disabled={disabled}
        >
            Save
        </Button>
    );
}

export const CopyButton = ({ onClick, handleSetDialog, disabled }) => {
    return (
        <Button
            className="custom-edit-button"
            type="default"
            icon={<CopyOutlined />}
            style={customStyle}
            onClick={() =>
                handleSetDialog([
                    { key: DIALOG_KEY.OPEN, value: true },
                    { key: DIALOG_KEY.TITLE, value: "복사 확인" },
                    { key: DIALOG_KEY.BODY, value: "복사 하시겠습니까?" },
                    { key: DIALOG_KEY.HANDLE, value: onClick },
                    { key: DIALOG_KEY.BUTTON_TEXT, value: "복사" },
                    { key: DIALOG_KEY.USE_INPUT, value: false }
                ])
            }
            disabled={disabled}
        >
            Copy
        </Button>
    );
}

export const CancelButton = ({ onClick, disabled }) => {
    return (
        <Button
            className="custom-edit-button"
            type="default"
            icon={<CloseOutlined />}
            style={customStyle}
            onClick={onClick}
            disabled={disabled}
        >
            Cancel
        </Button>
    );
}

export const DeleteButton = ({ onClick, handleSetDialog, display, disabled }) => {
    return (
        <Button
            className="custom-edit-button"
            type="default"
            danger
            icon={<DeleteOutlined />}
            style={{ ...customStyle, ...(display === 'none' ? { display: 'none' } : {}) }}
            onClick={() =>
                handleSetDialog([
                    { key: DIALOG_KEY.OPEN, value: true },
                    { key: DIALOG_KEY.TITLE, value: "삭제 확인" },
                    { key: DIALOG_KEY.BODY, value: "삭제를 원하시면 'DELETE' 를 입력하세요." },
                    { key: DIALOG_KEY.HANDLE, value: onClick },
                    { key: DIALOG_KEY.BUTTON_TEXT, value: "삭제" },
                    { key: DIALOG_KEY.USE_INPUT, value: true }
                ])
            }
            disabled={disabled}
        >
            Delete
        </Button>
    );
}

export const FixButton = ({ onClick, handleSetDialog, disabled }) => {
    return (
        <Button
            className="custom-edit-button"
            type="default"
            icon={<CheckOutlined />}
            style={customStyle}
            onClick={() =>
                handleSetDialog([
                    { key: DIALOG_KEY.OPEN, value: true },
                    { key: DIALOG_KEY.TITLE, value: "최종 확정" },
                    { key: DIALOG_KEY.BODY, value: "최종 확정 하시겠습니까? 확정 후엔 수정 및 삭제되지 않습니다." },
                    { key: DIALOG_KEY.HANDLE, value: onClick },
                    { key: DIALOG_KEY.BUTTON_TEXT, value: "확정" },
                    { key: DIALOG_KEY.USE_INPUT, value: false }
                ])
            }
            disabled={disabled}
        >
            Fix
        </Button>
    );
}